import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreCouponsState = createSelector(
  getStorePageState,
  (state) => state.couponsState
);
export const getStoreCouponsIsLoading = createSelector(
  getStoreCouponsState,
  (coupons) => coupons.isLoading
);
export const getStoreCouponsData = createSelector(
  getStoreCouponsState,
  (coupons) => coupons.data
);
export const getStoreCouponsHasBeenFetched = createSelector(
  getStoreCouponsState,
  (coupons) => coupons.fetched
);
export const getStoreCouponsError = createSelector(
  getStoreCouponsState,
  (coupons) => coupons.error
);
export const getStoreCouponsSuccess = createSelector(
  getStoreCouponsState,
  (coupons) => coupons.success
);
